import styled, { css } from 'styled-components'

export const StyledEditorialStories = styled.div``
